module.exports = __webpack_public_path__ + "img/3.23d1bd57.png";